var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { mergeQueryString, updateSearch } from 'bernie-core';
import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { useStores } from '../../utils/hooks/useStores';
import { getPageId } from '../../helpers/common-helper';
import { ChangeSearchCollapsedButton } from './change-search-collapsed-button';
import { parse } from 'query-string';
import { SearchUpdate } from './search-update';
var shouldFocusOnTrigger = false;
export var SrpSearchForm = function (_a) {
  var onSubmit = _a.onSubmit,
    forceOpen = _a.forceOpen,
    searchQuery = _a.searchQuery,
    searchUpdateProps = __rest(_a, ["onSubmit", "forceOpen", "searchQuery"]);
  var _b = useStores(),
    analytics = _b.analytics,
    activitySearchStore = _b.activitySearchStore,
    context = _b.context,
    searchCriteriaStore = _b.searchCriteriaStore;
  var history = useHistory();
  var location = useLocation();
  var numOfDaysBookableInAdvance = searchCriteriaStore.numOfDaysBookableInAdvance;
  var submit = function (query) {
    onSubmit(query);
  };
  var queryParams = parse(location.search);
  var showEditableForm = queryParams && queryParams.srpOpen === 'true' || !searchQuery.location && !searchQuery.rid || forceOpen;
  var pageId = getPageId(activitySearchStore);
  var changeSearchRfrrId = "LX.".concat(pageId, ".ChangeSearch");
  var searchFormTriggerRef = React.useRef(null);
  var searchFormHeadingRef = React.useRef(null);
  var openSearchForm = function () {
    var updatedQuery = mergeQueryString(location.search, {
      srpOpen: true
    });
    updateSearch({
      history: history,
      location: location,
      newParams: updatedQuery,
      newState: {},
      replace: true
    });
    analytics.trackEvent(changeSearchRfrrId, 'change-search-clicked', analytics.omnitureData);
  };
  React.useEffect(function () {
    if (showEditableForm && searchFormHeadingRef.current) {
      searchFormHeadingRef.current.focus();
      shouldFocusOnTrigger = true;
    } else if (shouldFocusOnTrigger && !showEditableForm && searchFormTriggerRef.current) {
      searchFormTriggerRef.current.focus();
    }
  }, [showEditableForm, searchFormHeadingRef]);
  return React.createElement(React.Fragment, null, React.createElement(Viewport, null, React.createElement(ViewSmall, null, showEditableForm ? React.createElement(SearchUpdate, __assign({}, searchUpdateProps, {
    numDaysBookableInAdvance: numOfDaysBookableInAdvance,
    onSubmit: submit,
    searchQuery: searchQuery,
    onMobile: true,
    searchFormHeadingRef: searchFormHeadingRef
  })) : React.createElement(ChangeSearchCollapsedButton, {
    searchFormTriggerRef: searchFormTriggerRef,
    openSearchForm: openSearchForm,
    searchQuery: searchQuery,
    localDateFormat: context.localDateFormat
  })), React.createElement(ViewMedium, null, React.createElement(SearchUpdate, __assign({}, searchUpdateProps, {
    numDaysBookableInAdvance: numOfDaysBookableInAdvance,
    onSubmit: submit,
    searchQuery: searchQuery,
    onMobile: false
  })))));
};